import React, { useEffect } from 'react';
import { ContentBox, ContentBoxBody, ContentBoxHead } from '../Components/ContentBox';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import IfLoggedIn from '../Components/IfLoggedIn';
import IfLoggedOut from '../Components/IfLoggedOut';
import BannerCarousel from '../Components/BannerCarousel';
import HomeLoginBox from '../Components/HomeLoginBox';
import EnterTickets from '../Components/Enter_old/EnterTickets';
import ActiveSweepstakes from '../Components/Sweepstakes/ActiveSweepstakes';
import Layout from '../Components/Layout';
import { formatDateTBD, getCMSObject, CMSContent, NextDrawings, TeleScript } from 'sg-ui-components';
import promotionConfig from '../promotionConfig';
import UserLockout from '../utils/user_lockout';

const homePage = ({ user, config, winner, cmsSourceFirebase, match, actions }) => {
    useEffect(() => {
        actions.sweepActions.getSweeps();
    }, [actions]);

    const telescriptNextDrawing = getCMSObject('data.components.teleScripts.nextDrawing.jsonBlock');

    const renderCarouselItem = (drawing) => (
        <div className='next-drawing-card mt-2 mb-5'>
            <h3>{drawing.promotion}</h3>
            <div>{drawing.drawing_date}</div>
            <hr className='next-drawing-divider' />

            <div>
                <TeleScript line={telescriptNextDrawing?.promotionText}>Want More Chances to Win? </TeleScript>
            </div>

            <Button className='next-drawing-button' href='/enter'>
                Enter Now
            </Button>
        </div>
    );

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='home-container'>
                <div className='row no-gutters'>
                    <div className='col-md-3'>
                        <HomeLoginBox />
                    </div>
                    <div className='col-md-9'>
                        <div className='h-100 hero-carousel'>
                            <BannerCarousel name='ctl_home_page_carousel' />
                        </div>
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-6 p-3 entry-box'>
                        <IfLoggedIn>
                            <UserLockout>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.webNotices'
                                    className=''
                                    noticePlacement='web-notice-ticket-entry'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                    delayToShow={1000}>
                                    <EnterTickets />
                                </CMSContent>
                            </UserLockout>
                        </IfLoggedIn>
                        <IfLoggedOut>
                            <ContentBox variant='theme-green'>
                                <ContentBoxHead>ENTER TICKETS</ContentBoxHead>
                                <ContentBoxBody>
                                    <div className='enter-logged-out text-center'>
                                        <div className='line-under'>Enter eligible scratch tickets into 2nd Chance promotions from the CT Lottery!</div>
                                        <div className='good-luck'>
                                            <a href='/enter'>Want to enter your tickets?</a>
                                            <br />
                                            <a href='/login'>Login or Register for a 2nd chance account. Good Luck!</a>
                                        </div>
                                    </div>
                                </ContentBoxBody>
                            </ContentBox>
                        </IfLoggedOut>
                    </div>
                    <div className='col-md-6 p-3'>
                        <NextDrawings
                            {...{ user, winner, cmsSourceFirebase, actions }}
                            formatDate={formatDateTBD?.dateWithDayOfTheWeek}
                            telescript={telescriptNextDrawing ?? ''}
                            options={{
                                variant: 'theme-blue',
                                limitOnePerSweepstake: promotionConfig?.nextDrawingsLimitOnePerSweepstake ?? true,
                                maxElement: promotionConfig?.nextDrawingsMaxElement ?? 5,
                                promotionDetailsLink: '/promotion',
                            }}
                            renderCarouselItem={renderCarouselItem}
                        />
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-12 p-3'>
                        <ActiveSweepstakes displayCount={6} title='PROMOTIONS' variant='theme-purple' buttons='view-all-promotions' />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(homePage);
